module.exports = __webpack_public_path__ + "static/media/html icon.a5481f9c.svg";